export const PRODUCTOS_BASE_OBJ = {
  PRODUCTOS: {
    children: [{ // PRODOCTO EJEMPLO
        children: [ //Categoria
          {},
          {
            children: [ //Subcategoria
              {},
              {
                children: [ //Linea
                  {},
                  { //Producto
                    delete: false,
                    id: 'OvrJ0058hSeji0Xe8dTo',
                    id_nivel1: 'b47348d5-48c0-4801-8d12',
                    id_nivel2: 'b26dab22-adf2-4588-b5fc',
                    id_nivel3: 'ee2b1c38-1ff6-4723-8b74',
                    name: 'Producto1',
                    name_nivel1: 'Categoria',
                    name_nivel2: 'Subcategoria',
                    name_nivel3: 'Linea',
                    nivel: 4
                  }

                ],
                delete: false,
                id: 'ee2b1c38-1ff6-4723-8b74',
                id_nivel1: 'b47348d5-48c0-4801-8d12',
                id_nivel2: 'b26dab22-adf2-4588-b5fc',
                name: 'Linea',
                name_nivel1: 'Categoria',
                name_nivel2: 'Subcategoria',
                nivel: 3
              }

            ],
            id: 'b26dab22-adf2-4588-b5fc',
            id_nivel1: 'b47348d5-48c0-4801-8d12',
            delete: false,
            name: 'Subcategoria',
            name_nivel1: 'Categoria',
            nivel: 2
          }
        ],
        delete: false,
        id: 'b47348d5-48c0-4801-8d12',
        name: 'Categoria',
        nivel: 1
      },

    ],
    name: "Productos",
    version: "1.0",
  },
  PRODUCTO: {
    codigoBarra: '',
    nombre: 'Producto1',
    sucursal: [],
    claveSat: '',
    descripcion: '',
    presentacion: 0,
    unidadMedida: 'Gramos (g)',
    marca: '',
    precioCompra: 100.00,
    SKU: 'SKU',
    precioVenta: 100.00,
    codigoBarraFabrica: '9955437465476',
    estatus: {
      fecha_baja: {},
      activo: 'activo',
    },
    info: {
      fecha_alta: '',
      fecha_nacimiento: '',
    },
    motivosBaja: '',
    compartir: {
      es_publico: true,
      en_sucursales: {}
    }
  }
}

export const PRODUCTO_BASE_OBJ = {
  /*franquicia:'',*/
  codigoBarra: '',
  nombre: '',
  sucursal: [],
  claveSat: '',
  descripcion: '',
  presentacion: 0,
  unidadMedida: '',
  marca: '',
  precioCompra: 0,
  SKU: '',
  precioVenta: 0,
  codigoBarraFabrica: '',
  estatus: {
    fecha_baja: {},
    activo: 'activo',
  },
  info: {
    fecha_alta: '',
    fecha_nacimiento: '',
  },
  motivosBaja: '',
  compartir: {
    es_publico: true,
    en_sucursales: {}
  }
}


export const DATA_BASE_OBJ = {
  productoNameSeleccionado: '',
  productoSeleccionado_lv1: '',
  productoSeleccionado_lv2: '',
  productoSeleccionado_lv3: '',
  productoSeleccionado_lv4: '',
  productoIdLv1Seleccionado: '',
  productoIdLv2Seleccionado: '',
  productoIdLv3Seleccionado: '',
  productoIdLv4Seleccionado: '',
  productoNivelSeleccionado: '',
  sucursales: []
}

export const UNIDADES_MEDIDA_BASE_OBJ = [
  "Kilogramos (kg)", "Litro (lt)", "Pieza (pza)", "Mililitro (ml)",
  "Caja (caj)", "Tableta (tab)", "Bolsa (bsa)", "Bultos (bto)",
  "Ampolleta (amp)", "Frascos (fco)", "Paquete (paq)", "Gramos (g)",
  "Lata (lta)", "Unidad (und)", "Comprimido (comp)", "Tubo (tub)",
  "Dosi (dosi)", "Par (par)", "Servicio (ser)", "Garrafon (gafon)"
];



// WEBPACK FOOTER //
// ./src/constantes/productos.js